<template v-if="archiveActive">
  <div class="o-page__content">
    <h1 class="u-visually-hidden"></h1>

    <div class="o-grid">
      <div
        class="o-grid__item md:1/2 lg:1/3"
        :key="project"
        v-for="project in group"
      >
        <Thumbnail page="archive" :project="projects[project]" />
      </div>
    </div>

  </div>
</template>


<script>
import { mapState } from 'vuex';
import Thumbnail from '@/components/Thumbnail.vue';

export default {
  computed: mapState({
    archiveActive: state => state.archive !== null,
    group: state => state.archive || null,
    projects: state => state.projects || null,
    title: state => (state.hasLoaded ? state.seo.groups.archive.title : state.defaultMetaTitle),
    description(state) {
      return state.hasLoaded ? state.seo.groups.archive.description : state.defaultMetaDescription;
    },
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.description,
      }],
    };
  },
  components: { Thumbnail },
};
</script>
